// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top .steps[data-v-ad30e014] {\n  padding: 20px 30px;\n}", ""]);
// Exports
module.exports = exports;
